import { GraphQLClient } from 'graphql-request';
import { gql } from 'urql';
import {
  Mutation,
  Query,
  QueryAssignedBaaAccountsForFirmMemberArgs,
  QueryUnassignedBaaAccountsForFirmMemberArgs,
  MutationRevokeUserAccessArgs,
  CreateBaaAccountInput,
  RemoveAssignedAccountInput,
  QueryBaaPersonForSelfArgs,
  CreateBaaPersonInput,
} from '../generated/graphql';
import { BaaAccountFragment, UnassignedBaaAccountFragment } from './fragments';

export const getUnassignedBaaAccountsForFirmMemberQuery = gql`
  ${UnassignedBaaAccountFragment}
  query UnassignedBaaAccountsForFirmMember($firmID: ID!, $firmMemberID: ID!) {
    unassignedBaaAccountsForFirmMember(firmID: $firmID, firmMemberID: $firmMemberID) {
      items {
        ...UnassignedBaaAccountFragment
      }
    }
  }
`;

export const clientGetUnassignedBaaAccountsForFirmMember = async (
  client: GraphQLClient,
  args: QueryUnassignedBaaAccountsForFirmMemberArgs
) => {
  return (
    await client.request<Pick<Query, 'unassignedBaaAccountsForFirmMember'>>(
      getUnassignedBaaAccountsForFirmMemberQuery,
      args
    )
  ).unassignedBaaAccountsForFirmMember;
};

export const getAssignedBaaAccountsForFirmMemberQuery = gql`
  ${BaaAccountFragment}
  query AssignedBaaAccountsForFirmMember($firmID: ID!, $firmMemberID: ID!) {
    assignedBaaAccountsForFirmMember(firmID: $firmID, firmMemberID: $firmMemberID) {
      items {
        ...BaaAccountFragment
      }
    }
  }
`;

export const clientGetAssignedBaaAccountsForFirmMember = async (
  client: GraphQLClient,
  args: QueryAssignedBaaAccountsForFirmMemberArgs
) => {
  return (
    await client.request<Pick<Query, 'assignedBaaAccountsForFirmMember'>>(
      getAssignedBaaAccountsForFirmMemberQuery,
      args
    )
  ).assignedBaaAccountsForFirmMember;
};

export const revokeUserAccessMutation = gql`
  mutation RevokeUserAccess($firmID: ID!) {
    revokeUserAccess(firmID: $firmID) {
      revoked
    }
  }
`;

export const clientRevokeUserAccess = async (client: GraphQLClient, input: MutationRevokeUserAccessArgs) => {
  const { revokeUserAccess } = await client.request<Pick<Mutation, 'revokeUserAccess'>>(
    revokeUserAccessMutation,
    input
  );

  return revokeUserAccess;
};

const createBaaAccountMutation = gql`
  ${BaaAccountFragment}
  mutation CreateBaaAccount($input: CreateBaaAccountInput!) {
    createBaaAccount(input: $input) {
      account {
        ...BaaAccountFragment
      }
    }
  }
`;

export const clientCreateBaaAccount = async (client: GraphQLClient, input: CreateBaaAccountInput) => {
  const { createBaaAccount } = await client.request<Pick<Mutation, 'createBaaAccount'>>(createBaaAccountMutation, {
    input,
  });

  return createBaaAccount;
};

const removeAssignedAccountMutation = gql`
  mutation RemoveAssignedAccount($input: RemoveAssignedAccountInput!) {
    removeAssignedAccount(input: $input) {
      deleted
    }
  }
`;

export const clientRemoveAssignedAccount = async (client: GraphQLClient, input: RemoveAssignedAccountInput) => {
  const { removeAssignedAccount } = await client.request<Pick<Mutation, 'removeAssignedAccount'>>(
    removeAssignedAccountMutation,
    { input }
  );

  return removeAssignedAccount;
};

const getBaaPersonForSelfQuery = gql`
  query BaaPersonForSelf($firmID: ID!) {
    baaPersonForSelf(firmID: $firmID) {
      id
    }
  }
`;

export const clientGetBaaPersonForSelf = async (client: GraphQLClient, args: QueryBaaPersonForSelfArgs) => {
  return (await client.request<Pick<Query, 'baaPersonForSelf'>>(getBaaPersonForSelfQuery, args)).baaPersonForSelf;
};

const createBaaPersonMutation = gql`
  mutation CreateBaaPerson($input: CreateBaaPersonInput!) {
    createBaaPerson(input: $input) {
      baaPerson {
        username
      }
      temporaryPassword
    }
  }
`;

export const clientCreateBaaPerson = async (client: GraphQLClient, input: CreateBaaPersonInput) => {
  const { createBaaPerson } = await client.request<Pick<Mutation, 'createBaaPerson'>>(createBaaPersonMutation, {
    input,
  });

  return createBaaPerson;
};

export const getUnassignedBaaAccountsForFirmQuery = gql`
  ${UnassignedBaaAccountFragment}
  query UnassignedBaaAccountsForFirm($firmID: ID!) {
    unassignedBaaAccountsForFirm(firmID: $firmID) {
      items {
        ...UnassignedBaaAccountFragment
      }
    }
  }
`;

export const getAssignedBaaAccountsForFirmQuery = gql`
  ${BaaAccountFragment}
  query AssignedBaaAccountsForFirm($firmID: ID!) {
    assignedBaaAccountsForFirm(firmID: $firmID) {
      items {
        ...BaaAccountFragment
      }
    }
  }
`;

export const removeBAAAccountsForNetWorthItemMutation = gql`
  mutation RemoveBAAAccountsForNetWorthItem($householdID: ID!, $mappedEntityID: ID!) {
    removeBAAAccountsForNetWorthItem(householdID: $householdID, mappedEntityID: $mappedEntityID)
  }
`;
